export const API_BASE_URL = 'https://marketplace-api.getzorba.com';

export const EXTERNAL_LINKS = {
  REST_WIKI: 'http://en.wikipedia.org/wiki/Representational_State_Transfer',
  FORM_ENCODED: 'https://en.wikipedia.org/wiki/POST_(HTTP)#Use_for_submitting_web_forms',
  JSON_SPEC: 'http://www.json.org/',
}; 